const defaultEmailTemplate = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
<title>Lead Lens AI Report for {tenant-name}</title>
<!--[if gte mso 9]>
<xml>
  <o:OfficeDocumentSettings>
    <o:AllowPNG/>
    <o:PixelsPerInch>96</o:PixelsPerInch>
  </o:OfficeDocumentSettings>
</xml>
<![endif]-->
<style type="text/css">
  body, table, td, p, a, li, blockquote {
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    font-family: Arial, sans-serif;
  }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: #f0f0f0;">

<%
  function scoreColor(score) {
    const colors = {
      1: '#ff0000', 2: '#ff3300', 3: '#ff6600', 4: '#ff9900', 5: '#ffcc00',
      6: '#cccc00', 7: '#99cc00', 8: '#66cc00', 9: '#33cc00', 10: '#00cc00'
    };
    return colors[score] || '#aaaaaa';
  }

  function leadRankDescription(score) {
    const descriptions = {
      1: 'Needs attention',
      2: 'Low interest',
      3: 'Mild potential',
      4: 'Lukewarm lead',
      5: 'Moderate prospect',
      6: 'Promising lead',
      7: 'Strong potential',
      8: 'High value prospect',
      9: 'Excellent opportunity',
      10: 'Prime lead'
    };
    return descriptions[score] || 'Unknown';
  }

  function leadRankDescriptionWeight(score) {
    return 400 + (score * 30); // 400 to 700
  }

  function leadRankDescriptionBg(score) {
    const baseColor = scoreColor(score);
    return lightenColor(baseColor, 40); // Slightly lighter shade
  }

  function lightenColor(color, amount) {
    return '#' + color.replace(/^#/, '').replace(/../g, color => ('0' + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2));
  }

  function callerName(firstName, lastName, defaultName) {
    let name = "";
    if(firstName && firstName.length > 0)
      name = name + firstName;
    if(lastName && lastName.length > 0)
      name = name + " " + lastName;
    if(name.length == 0)
      name = defaultName;
    return name;
  }
%>

  <table cellpadding="0" cellspacing="0" border="0" width="100%" style="background-color: #f0f0f0;">
    <tr>
      <td align="center" style="padding: 20px 0;">
        <table cellpadding="0" cellspacing="0" border="0" width="600" style="background-color: #ffffff;">
          <!-- Logo -->
          <tr>
            <td style="padding: 20px; background-color: #ffffff;">
              <img src="https://leadlensai.com/wp-content/uploads/2024/03/lead-lens-logo-52.png" alt="Lead Lens AI Logo" style="display: block;max-width: 240px;text-align: center;margin-left: auto;" />
            </td>
          </tr>
          
          <!-- Header with Lead Rank -->
          <tr>
            <td style="padding: 20px; background-color: #1e7ddc;">
              <table cellpadding="0" cellspacing="0" border="0" width="100%">
                <tr>
                  <td width="40%" style="vertical-align: middle;">
                    <table cellpadding="0" cellspacing="0" border="0" width="100%">
                      <tr>
                        <td style="background-color: <%= scoreColor(questions.LeadRank) %>; width: 70px; height: 70px; text-align: center; vertical-align: middle;">
                          <div style="font-size: 36px; color: #ffffff; font-weight: bold;">
                            <%= questions.LeadRank %>
                          </div>
                        </td>
                        <td style="padding-left: 15px; text-align: left;">
                          <p style="font-size: 18px; color: #ffffff; margin: 0; font-weight: 600;">Lead Rank</p>
                          <p style="font-size: 12px; color: #333333; margin: 5px 0 0 0; background-color: <%= leadRankDescriptionBg(questions.LeadRank) %>; display: inline-block; padding: 3px 8px;"><%= leadRankDescription(questions.LeadRank) %></p>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td width="60%" style="vertical-align: middle; text-align: right;">
                    <h1 style="margin: 0; font-size: 22px; color: #ffffff;"><%= company_name %></h1>
                    <p style="margin: 5px 0 0; font-size: 16px; color: #ffffff; font-weight:bold;"><%= callerName(questions.FirstName, questions.LastName, customer_name) %></p>
                    <p style="margin: 5px 0 0; font-size: 12px; color: #e1e1e1;">ID: <%= id %></p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Contact Information -->
          <tr>
            <td style="padding: 20px 40px; background-color: #ffffff;">
              <h2 style="font-size: 20px; color: #1e7ddc; margin: 0 0 15px 0; border-bottom: 2px solid #1e7ddc; padding-bottom: 10px;">Contact Information</h2>
              <table cellpadding="0" cellspacing="0" border="0" width="100%">
                <tr>
                  <td width="50%" style="vertical-align: top; padding-right: 10px;">
                    <p style="font-size: 14px; margin: 0 0 10px 0;"><strong>Name:</strong> <%= callerName(questions.FirstName, questions.LastName, customer_name) %></p>
                    <p style="font-size: 14px; margin: 0 0 10px 0;"><strong>Email:</strong> <%= questions.Email || 'N/A' %></p>
                    <p style="font-size: 14px; margin: 0 0 10px 0;"><strong>Phone:</strong> <%= questions.Phone && questions.Phone.replace(/\\D/g, '').length >= 10 ? questions.Phone : customer_phone_number %></p>
                  </td>
                  <td width="50%" style="vertical-align: top; padding-left: 10px;">
                    <p style="font-size: 14px; margin: 0 0 10px 0;"><strong>Date/Time:</strong> <%= start_time_local %></p>
                    <p style="font-size: 14px; margin: 0 0 10px 0;"><strong>Marketing Source:</strong> <%= source %></p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Call Summary -->
          <tr>
            <td style="padding: 20px 40px;">
              <h2 style="font-size: 20px; color: #1e7ddc; margin: 0 0 15px 0; border-bottom: 2px solid #1e7ddc; padding-bottom: 10px;">Call Summary</h2>
              <div style="background-color: #edf7ff; padding: 15px; border-left: 3px solid #1e7ddc;">
                <%= questions.CallSummary %>
              </div>
            </td>
          </tr><!-- Call Description -->
          <tr>
            <td style="padding: 20px 40px; background-color: #ffffff;">
              <h2 style="font-size: 20px; color: #1e7ddc; margin: 0 0 15px 0; border-bottom: 2px solid #1e7ddc; padding-bottom: 10px;">Call Description</h2>
              <table cellpadding="0" cellspacing="0" border="0" width="100%">
                <tr>
                  <td width="50%" style="vertical-align: top; padding-right: 10px;">
                    <p style="font-size: 14px; margin: 0 0 10px 0;"><strong>Caller Type:</strong> <%= questions.CallerType %></p>
                    <p style="font-size: 14px; margin: 0 0 10px 0;"><strong>Answered By:</strong> <%= questions.AnsweredBy %></p>
                    <p style="font-size: 14px; margin: 0 0 10px 0;"><strong>Language:</strong> <%= questions.Language || 'English' %></p>
                  </td>
                  <td width="50%" style="vertical-align: top; padding-left: 10px;">
                    <p style="font-size: 14px; margin: 0 0 10px 0;"><strong>Wrong Property:</strong> <%= questions.WrongProperty %></p>
                    <p style="font-size: 14px; margin: 0 0 10px 0;"><strong>Follow Up Required:</strong> <%= questions.FollowUpRequired %></p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Prospect Needs -->
          <tr>
            <td style="padding: 20px 40px; background-color: #f9f9f9;">
              <h2 style="font-size: 20px; color: #1e7ddc; margin: 0 0 15px 0; border-bottom: 2px solid #1e7ddc; padding-bottom: 10px;">Prospect Needs</h2>
              <table cellpadding="0" cellspacing="0" border="0" width="100%">
                <tr>
                  <td width="50%" style="vertical-align: top; padding-right: 10px;">
                    <p style="font-size: 14px; margin: 0 0 10px 0;"><strong>Unit Type:</strong> <%= questions.InterestedUnitType || 'N/A' %></p>
                    <p style="font-size: 14px; margin: 0 0 10px 0;"><strong>Move-in:</strong> <%= questions.MoveInTimeframe || 'N/A' %></p>
                    <p style="font-size: 14px; margin: 0 0 10px 0;"><strong>Budget:</strong> <%= questions.Budget || 'N/A' %></p>
                  </td>
                  <td width="50%" style="vertical-align: top; padding-left: 10px;">
                    <p style="font-size: 14px; margin: 0 0 10px 0;"><strong>Affordable Housing:</strong> <%= questions.AffordableHousing %></p>
                    <p style="font-size: 14px; margin: 0 0 10px 0;"><strong>Credit Score:</strong> <%= questions.CreditScore || 'N/A' %></p>
                    <p style="font-size: 14px; margin: 0;"><strong>Move-in Date:</strong> <%= questions.MoveInDate || 'N/A' %></p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Full Call Transcript -->
          <tr>
            <td style="padding: 20px 40px; background-color: #ffffff;">
              <h2 style="font-size: 20px; color: #1e7ddc; margin: 0 0 15px 0; border-bottom: 2px solid #1e7ddc; padding-bottom: 10px;">Full Call Transcript</h2>
              <div style="background-color: #f9f9f9; padding: 15px; border: 1px solid #e0e0e0; border-left: 4px solid #1e7ddc;">
                <%- htmlTranscription %>
              </div>
            </td>
          </tr>

          <!-- Footer -->
          <tr>
            <td style="padding: 20px; background-color: #1e7ddc; text-align: center;">
              <p style="font-size: 14px; color: #ffffff; margin: 0;">© 2024 Lead Lens AI. All rights reserved.</p>
              <p style="font-size: 14px; color: #ffffff; margin: 10px 0 0 0;">Powered by advanced AI for smarter lead management.</p>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>`;

export default defaultEmailTemplate;
